export const PROJECTS_QUERY_KEY = 'projects';
export const GITLAB_GROUPS_KEY = 'gitlab-groups';
export const GITLAB_SUBGROUPS_KEY = 'gitlab-subgroups';
export const CLI_QUERY_KEY = 'cli-data';
export const IAS_PROJECTS_QUERY_KEY = 'ias-projects';
export const IAS_PROJECT_CONFIG_QUERY_KEY = 'ias-project-config';
export const IAS_PROJECT_TEMPLATE_README_QUERY_KEY =
  'ias-project-template-readme';
export const IAS_PROJECT_USED_UNIQUE_VALUES_QUERY_KEY =
  'ias-project-used-unique-values';
export const IAS_PROJECT_INSTANCE_STATE_QUERY_KEY =
  'ias-project-instance-state';
export const DEFAULT_PARAM_GROUP = 'default-param-group';
export const DEFAULT_FEATURE_GROUP = 'default-feature-group';
export const RECOMMENDED_FEATURE_GROUP = 'recommended-feature-group';
export const USERS_KEY = 'users';
export const SONAR_PERMISSION_GROUPS = 'sonar-permission-groups';
export const PROJECT_PRESETS_QUERY_KEY = 'project-presets-query-key';
export const ITEMS_PER_PAGE = 20;
export const ATLASSIAN_JIRA_PROJECT_KEY = 'atlassian-jira-project';
export const ATLASSIAN_CONFLUENCE_SPACE_ID = 'atlassian-confluence-space-id';
export const ATLASSIAN_CONFLUENCE_SPACES = 'atlassian-confluence-spaces';
export const ATLASSIAN_CONFLUENCE_PAGE_CHILDREN =
  'atlassian-confluence-page-children';
export const GIT_REMOTE_REF_KEY = 'git-remote-ref';
export const SPDX_LICENSES_KEY = 'spdx-licenses';
export const GITLAB_OSEP_PIPELINE_VARIABLE_QUERY_KEY =
  'osep-gitlab-pipeline-variable';
export const CONNECTIONS_QUERY_KEY = 'connections';
export const CONNECTIONS_POLL_INTERVAL_MS = 3_000;
export const OAUTH_FLOW_ERRORS: Record<string, string> = {
  access_denied: 'You declined access at the provider.',
  flow_binding_failed:
    'The connection could not be completed in this browser. Please start it again here.',
  provider_error: 'The provider reported an error. Please try again.',
  exchange_failed:
    'The provider could not complete the connection. Please try again.',
};
// Problem types of the generator service's 403 answers a client acts on, see its API description.
export const PROVIDER_NOT_CONNECTED_PROBLEM_TYPE =
  'urn:osep:problems:provider-not-connected';
export const INSUFFICIENT_PROVIDER_ACCESS_PROBLEM_TYPE =
  'urn:osep:problems:insufficient-provider-access';
